import type { API } from 'api/config/types';
import { getExpectedGameDuration } from 'plugins/clocks//model/get-expected-game-duration';
import { MIN_EXPECTED_BLITZ_TIME, MAX_EXPECTED_BLITZ_TIME } from 'plugins/clocks/config/constants';
import { TimeControl } from 'chessboard/api/time-control/config/types';

/**
 * Create the getTimeControlType method.
 */
export function createGetTimeControlType(context: API.Context) {
  /**
   * Get the time control type.
   */
  return function getTimeControlType(): TimeControl.Types {
    const { api } = context;

    const timeControl = api.timeControl.get();

    if (timeControl) {
      const expectedDuration = getExpectedGameDuration(timeControl);

      if (expectedDuration < MIN_EXPECTED_BLITZ_TIME) {
        return TimeControl.Types.Bullet;
      }

      if (expectedDuration > MAX_EXPECTED_BLITZ_TIME) {
        return TimeControl.Types.Rapid;
      }
    }

    return TimeControl.Types.Blitz;
  };
}
